import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Body1, Body2 } from '@ui/Typography'

import { PromoAssetFields } from './PromoPreview.modal'

import styles from './PromoPreviewModal.module.scss'

interface Props {
  fields: PromoAssetFields
}

export const PromoPreviewHtmlCode: FC<Props> = ({ fields }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.htmlCodeContainer}>
      <Body1 medium color='text-high-em'>
        {t('Referral Materials.HTML Code')}
      </Body1>

      <Body2 isParagraph className={styles.htmlCode}>
        {fields.htmlCode}
      </Body2>
    </div>
  )
}
